import React from 'react';
import { Users, Download, Upload, Plus, ShieldCheck, Shield, Headset, ExternalLink } from 'lucide-react';
import AssigneePicker from './AssigneePicker.jsx';

export default function LeadsHeader({
  assignee,
  setAssignee,
  setPage,
  agents,
  isAdmin,
  isSuperAdmin = false,
  directOnly = false,
  onToggleDirectOnly,
  onOpenCsvWizard,
  onUploadCsv,
  onCreateLead,
}) {
  return (
    <header className="flex items-center justify-between flex-wrap gap-3">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-xl bg-civix-purple/20 flex items-center justify-center">
          <Users className="w-5 h-5 text-civix-purpleSoft" />
        </div>
        <div>
          <div className="text-civix-purpleSoft/80 uppercase tracking-[0.3em] text-[10px]">CRM</div>
          <h1 className="font-display text-2xl font-bold">View Leads</h1>
        </div>
      </div>

      <div className="flex items-center gap-2 flex-wrap">
        {/* Super Admin Global Switcher */}
        {isSuperAdmin && (
          <div className="inline-flex items-center bg-black/40 border border-civix-border/70 rounded-lg p-1 gap-1 mr-2 shadow-inner">
            <button
              type="button"
              onClick={() => onToggleDirectOnly?.(false)}
              className={`px-3 py-1.5 text-xs rounded-md font-medium transition flex items-center gap-1.5 cursor-pointer ${
                !directOnly
                  ? 'bg-civix-purple text-white shadow-sm font-semibold'
                  : 'text-white/60 hover:text-white hover:bg-white/5'
              }`}
            >
              <ShieldCheck className="w-3.5 h-3.5" />
              View All Agency Data
            </button>
            <button
              type="button"
              onClick={() => onToggleDirectOnly?.(true)}
              className={`px-3 py-1.5 text-xs rounded-md font-medium transition flex items-center gap-1.5 cursor-pointer ${
                directOnly
                  ? 'bg-civix-purple text-white shadow-sm font-semibold'
                  : 'text-white/60 hover:text-white hover:bg-white/5'
              }`}
            >
              <Shield className="w-3.5 h-3.5" />
              View My Direct Team
            </button>
          </div>
        )}

        <AssigneePicker
          value={assignee}
          onChange={(v) => { setAssignee(v); setPage(1); }}
          agents={agents}
          isAdmin={isAdmin}
          directOnly={directOnly}
        />
        <a
          href="https://inbounds.civixcrm.ai/booth"
          target="_blank"
          rel="noopener noreferrer"
          className="btn-ghost flex items-center gap-1.5 text-civix-cyan hover:text-white border border-civix-cyan/30 hover:border-civix-cyan transition"
          title="Launch the external live inbound transfer booth"
        >
          <Headset className="w-4 h-4 text-civix-cyan" />
          <span className="text-xs font-semibold tracking-wide">Take Inbound Calls</span>
          <ExternalLink className="w-3 h-3 opacity-60" />
        </a>
        <button onClick={onOpenCsvWizard} className="btn-ghost flex items-center gap-2 cursor-pointer">
          <Download className="w-4 h-4" />
          <span className="text-xs font-semibold tracking-wide">GENERATE CSV</span>
        </button>
        <button onClick={onUploadCsv} className="btn-ghost flex items-center gap-2 cursor-pointer">
          <Upload className="w-4 h-4" />
          <span className="text-xs font-semibold tracking-wide">UPLOAD CSV</span>
        </button>
        <button onClick={onCreateLead} className="btn-primary flex items-center gap-2 cursor-pointer">
          <Plus className="w-4 h-4" />
          <span className="text-xs font-semibold tracking-wide">CREATE LEAD</span>
        </button>
      </div>
    </header>
  );
}
